import { Button } from "@provenleap/ui";
import { Kanban, Table } from "@phosphor-icons/react";

export type TaskViewMode = "board" | "table";

interface ViewSwitcherProps {
  view: TaskViewMode;
  onViewChange: (view: TaskViewMode) => void;
}

export function ViewSwitcher({ view, onViewChange }: ViewSwitcherProps) {
  const nextView = view === "board" ? "table" : "board";
  const Icon = view === "board" ? Kanban : Table;
  const label = view === "board" ? "Board" : "Table";

  return (
    <Button
      variant="outline"
      className="shrink-0 rounded-2xl text-[13px] shadow-xs cursor-pointer hover:bg-background hover:-translate-y-0.5 hover:shadow-sm transition-all"
      style={{ border: "0.5px solid var(--hairline)" }}
      onClick={() => onViewChange(nextView)}
      aria-label={`Switch to ${nextView} view`}
    >
      <Icon size={16} className="mr-1" />
      {label}
    </Button>
  );
}
